import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
// components
import { Row } from '../../../../foundations/Grid';
import Typography from '../../../../foundations/Typography';
import Link from '../../../../components/Link';
import List from '../../../../components/List';
import SocialLinks from '../SocialLinks';
import WidowBlock from '../../../../components/WidowBlock';
// images
import NmAppDownloadQrCode from '../../../../../assets/images/nm-app-download-qr-code.png';
// styles
import {
  ColStyledDownloadLinkContainer,
  ColStyledDescriptiveText,
  ColStyledQrCodeContainer,
  ColStyledSocialLinks,
  ListItemStyledDownLoadLink,
  PictureStyledQrCode,
} from './styles';

const AppDownload = ({ config = { public: { googleAnalyticsTrackingId: '<%=googleAnalyticsTrackingId%>' } } }) => {
  const theme = useContext(ThemeContext);
  const mediumUp = theme.mediumUp();
  const mediumToLarge = theme.mediumToLarge();

  return (
    <>
      <Row>
        <ColStyledDescriptiveText>
          <Typography nextElement='button'>
            Download our app for fast, easy, and secure access to your accounts and more&#8212;<WidowBlock>anytime, anywhere.</WidowBlock>
          </Typography>
        </ColStyledDescriptiveText>
      </Row>
      <Row align='center'>
        <ColStyledDownloadLinkContainer
          align='center'
          medium={6}>
          <List reduced>
            <ListItemStyledDownLoadLink>
              <Link
                linkUrl='https://apps.apple.com/us/app/northwestern-mutual/id1132579006'
                isOutgoingLink>
                <img
                  alt='Download on the App Store'
                  src={`${config.basePath}/template/assets/${config.nmxTemplateVersion}/images/badges/apple-app-store-badge.svg`}
                  className='nmx-icon badge-appStore'
                />
              </Link>
            </ListItemStyledDownLoadLink>
            <ListItemStyledDownLoadLink>
              <Link
                linkUrl='https://play.google.com/store/apps/details?id=com.nm.nm'
                isOutgoingLink>
                <img
                  alt='Get it on Google Play'
                  src={`${config.basePath}/template/assets/${config.nmxTemplateVersion}/images/badges/google-play-badge.png`}
                  className='nmx-icon badge-googlePlay'
                />
              </Link>
            </ListItemStyledDownLoadLink>
          </List>
        </ColStyledDownloadLinkContainer>
        {mediumUp && (
          <ColStyledQrCodeContainer
            medium={6}
            nested>
            <PictureStyledQrCode
              lazyLoad={false}
              variant='rectangular'
              src={NmAppDownloadQrCode}
              altText='Northwestern Mutual app QR Code'
              fullWidth
            />
          </ColStyledQrCodeContainer>
        )}
      </Row>
      {mediumToLarge && (
        <Row>
          <ColStyledSocialLinks>
            <SocialLinks />
          </ColStyledSocialLinks>
        </Row>
      )}
    </>
  );
};

AppDownload.propTypes = {
  /** Config vars used for varying components */
  config: PropTypes.shape({
    public: PropTypes.shape({ googleAnalyticsTrackingId: PropTypes.string }).isRequired,
  }),
};

export default AppDownload;
